export const ERROR_MESSAGES = {
  EMPTY_DATA: 'Erro ao importar planilha! Verifique se existe dados.',
  INSERT_NEW_DATA: 'Ocorreu um erro ao inserir novos dados.',
};
